import React, { useState, useCallback } from 'react';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonButton,
  IonSpinner,
  IonText,
  IonIcon,
  IonButtons,
  useIonViewWillEnter,
} from '@ionic/react';
import { useHistory } from 'react-router-dom';
import { add } from 'ionicons/icons';
import Header from '../components/Header';
import Footer from '../components/Footer';
import './PQRS.css';

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//       page_location: '/pages/PQRS',
//       page_title: 'PQRS'
//   }
// };

// console.log('Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (page_view):', error);
// });

interface props {
  netState: boolean;
}

interface TicketInfo {
  id: string;
  properties: {
    subject: string;
    hs_pipeline_stage: string;
  };
}

const ticketStatusMap: { [key: string]: string } = {
  '1': 'Nuevo',
  '2': 'Esperando al contacto',
  '3': 'Esperando acción por nuestra parte',
  '4': 'Cerrado'
};

const PQRSList: React.FC<props> = ({ netState }) => {
  const history = useHistory();
  const [tickets, setTickets] = useState<TicketInfo[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const fetchTickets = useCallback(async () => {
    if (!netState) {
        setError("Sin conexión a internet. No se pueden cargar los tickets.");
        setIsLoading(false);
        setTickets([]);
        return;
    }

    setIsLoading(true);
    setError(null);

    try {
      const storedIdsString = localStorage.getItem('userTicketIds');
      const ticketIds: string[] = storedIdsString ? JSON.parse(storedIdsString) : [];

      if (!Array.isArray(ticketIds)) {
           console.error("userTicketIds en localStorage no es un array válido.");
           setTickets([]);
           setIsLoading(false);
           setError("Error interno al leer los IDs de tickets guardados.");
           return;
      }

      if (ticketIds.length === 0) {
        setTickets([]);
        setIsLoading(false);
        return;
      }

      const backendUrl = `https://biinyugames.com/mastinpqrs/get_tickets.php?ids=${encodeURIComponent(JSON.stringify(ticketIds))}`;
      const response = await fetch(backendUrl);

      if (!response.ok) {
        let errorMsg = `Error ${response.status}: No se pudieron cargar los tickets.`;
        try {
          const errorData = await response.json();
          if (errorData && errorData.error) errorMsg = errorData.error;
        } catch (e) {}
        throw new Error(errorMsg);
      }

      const data: TicketInfo[] = await response.json();
      setTickets(data);

    } catch (err: any) {
      console.error("Error al cargar tickets:", err);
      setError(err.message || "Ocurrió un error desconocido al cargar los tickets.");
      setTickets([]);
    } finally {
      setIsLoading(false);
    }
  }, [netState]);


  useIonViewWillEnter(() => {
    fetchTickets();
  });


  const getReadableStatus = (stageId: string): string => {
    return ticketStatusMap[stageId] || stageId;
  }

  const navigateToCreate = () => {
    history.push('/create-ticket');
  };

  const navigateToDetail = (ticketId: string) => {
    history.push(`/ticket/${ticketId}`);
  };


  const showNetError = !netState && !isLoading && tickets.length === 0;

  return (
    <IonPage>
      <Header pageName="PQRS" />
      <IonHeader>
          <IonToolbar>
              <IonTitle>Mis PQRS</IonTitle>
              <IonButtons slot="end">
                  <IonButton onClick={navigateToCreate} fill="solid" color="primary">
                      <IonIcon slot="start" icon={add} />
                      Nuevo Ticket
                  </IonButton>
              </IonButtons>
          </IonToolbar>
      </IonHeader>

      <IonContent className="pqrs-content ion-padding">

        {showNetError && <h3 className="disconnect ion-padding ion-text-center">¡Comprueba tu conexión de internet!</h3>}


        {isLoading && <div className="ion-text-center ion-padding"><IonSpinner /></div>}


        {error && !isLoading && <IonText color="danger" className="ion-padding">{error}</IonText>}


        {!isLoading && !error && tickets.length === 0 && netState && (
          <IonText className="ion-padding">No has creado ningún ticket todavía.</IonText>
        )}


        {!isLoading && !error && tickets.length > 0 && (
          <IonList>
            {tickets.map((ticket) => (
              <IonItem key={ticket.id} lines="inset">
                <IonLabel>
                  <h2>{ticket.properties.subject || 'Sin Asunto'}</h2>
                  <p>Estado: {getReadableStatus(ticket.properties.hs_pipeline_stage)}</p>
                </IonLabel>
                <IonButton slot="end" fill="clear" onClick={() => navigateToDetail(ticket.id)}>
                  Ver Detalles
                </IonButton>
              </IonItem>
            ))}
          </IonList>
        )}
      </IonContent>
      <Footer />
    </IonPage>
  );
};

export default PQRSList;